import { render, staticRenderFns } from "./GeneralPopup.vue?vue&type=template&id=7f5883be&scoped=true&"
import script from "./GeneralPopup.vue?vue&type=script&lang=js&"
export * from "./GeneralPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPopup.vue?vue&type=style&index=0&id=7f5883be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5883be",
  null
  
)

export default component.exports